class e extends Error {
}
class a extends e {
  constructor(r) {
    super(`Assertion error: ${r}`), this.condition = r;
  }
}
class i extends e {
  constructor(r) {
    super(`${r || "This feature"} is not implemented yet`);
  }
}
class p extends e {
  constructor(r) {
    const o = r.map(
      (s) => s !== null && typeof s == "object" && "reason" in s ? s.reason : s
    ), n = o.map((s, c) => `[${c}] ${s instanceof Error ? s.message : String(s)}`).join("; ");
    super(`Partial batch operation success! Failures count: ${r.length}. Failures: ${n}`), this.failures = r, this.reasons = o;
  }
  /** Unwrapped rejection reason for each failure (the underlying errors). */
  reasons;
}
export {
  a as AssertionError,
  e as HpError,
  i as NotImplementedError,
  p as PartialBatchOperationSuccessError
};
//# sourceMappingURL=errors.js.map
